import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSave = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m20.821 9.6106c.32503 0 .62692.06257.9055.1877.27857.12512.52612.29612.74281.51302.21669.21687.3792.47964.48755.78828.10834.30864.17023.63814.18566.98849 0 .32532-.05811.64231-.17417.95095-.11606.30864-.28235.57974-.49904.81331l-8.3224 8.9715-4.3759 1.1762 1.0911-4.7172 8.3223-8.959c.2244-.2419.47606-.42125.75464-.53803.2784-.11678.57258-.17518.88201-.17518zm.59195 3.1156c.16252-.17517.24377-.38787.24377-.63813 0-.2586-.07731-.46714-.23212-.62563-.1548-.15849-.35589-.2419-.60361-.25025-.10834 0-.21275.01668-.31338.05006-.10063.03336-.1896.09591-.26692.18768l-8.0323 8.6586-.39465 1.6893 1.567-.42548zm-13.128 4.8923h1.4857l-1.4857 1.6017h-5.5135l-1.9152-2.0645v-15.553c0-.22522.038691-.43377.11607-.62561.077382-.19186.18185-.3587.3134-.50051.13155-.14181.29018-.25859.4759-.35035.18572-.091759.37917-.13347.58037-.12513h14.857c.20894 0 .4024.041709.58036.12513.17798.083415.3328.19603.46429.33784.13149.14181.23983.31281.32503.51302.08503.20019.12377.40874.11606.62561v6.4064l-1.4857 1.6016v-8.008h-1.4857v8.008h-11.886v-8.008h-1.4857v14.877l1.0563 1.1386h.42947v-6.4063h10.4v1.6016l-1.4857 1.6016v-1.6016h-7.4287v4.8047h1.4857v-3.2031h1.4857zm-2.9715-9.6095h8.9144v-6.4064h-8.9144z",
		fill: "currentColor",
		strokeWidth: 1.7143
	})]
});
const ForwardRef = forwardRef(SvgSave);
export { ForwardRef as ReactComponent };
